import React, { useEffect } from 'react'
import Navbar from '../HomePage/Navbar'
import ContactSection from '../HomePage/ContactSection'
import NewsLetter from '../HomePage/NewsLetter'
import Footer from '../HomePage/Footer'
import TermsAndConditions from './TermsAndCondition'

function TermsAndConditionIndex() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <TermsAndConditions />
      <ContactSection />
      <NewsLetter />
      <Footer />
    </div>
  )
}

export default TermsAndConditionIndex
